import { orderBy } from 'lodash';
import { RoomHeatLossDetailsFormModel } from '../../quote-or-design-form/rooms/heatLoss/roomHeatLossDetailsFormModel';
import {
  mapRoomFloorHeatLossDetailsResponseToFormModel,
  RoomFloorHeatLossDetailsResponse,
} from './roomFloorHeatLossDetailsResponse';
import {
  mapRoomRoofHeatLossDetailsResponseToFormModel,
  RoomRoofHeatLossDetailsResponse,
} from './roomRoofHeatLossDetailsResponse';
import {
  mapRoomWallHeatLossDetailsResponseToFormModel,
  RoomWallHeatLossDetailsResponse,
} from './roomWallHeatLossDetailsResponse';

export type RoomHeatLossDetailsResponse = {
  ceilingHeightInMetres: number | null;
  numberOfAirChangesPerHour: number | null;
  mechanicalVentilationHeatRecoveryEfficiencyPercentage: number | null;
  floorCoveringName: string | null;
  floorCoveringThermalResistancePerMillimetre: number | null;
  floorCoveringThicknessInMillimetres: number | null;
  deckingThermalResistancePerMillimetre: number | null;
  deckingThicknessInMillimetres: number | null;
  underlayThermalResistancePerMillimetre: number | null;
  underlayThicknessInMillimetres: number | null;
  userEnteredTotalHeatLossInWatts: number | null;
  walls: Array<RoomWallHeatLossDetailsResponse>;
  roofs: Array<RoomRoofHeatLossDetailsResponse>;
  floors: Array<RoomFloorHeatLossDetailsResponse>;
};

export const mapRoomHeatLossDetailsResponseToFormModel = (
  response: RoomHeatLossDetailsResponse,
): RoomHeatLossDetailsFormModel => ({
  ceilingHeightInMetres: response.ceilingHeightInMetres?.toString() ?? '',
  numberOfAirChangesPerHour: response.numberOfAirChangesPerHour?.toString() ?? '',
  mechanicalVentilationHeatRecoveryEfficiencyPercentage:
    response.mechanicalVentilationHeatRecoveryEfficiencyPercentage?.toString() ?? '',
  floorCoveringName: response.floorCoveringName,
  floorCoveringThermalResistancePerMillimetre: response.floorCoveringThermalResistancePerMillimetre?.toString() ?? '',
  floorCoveringThicknessInMillimetres: response.floorCoveringThicknessInMillimetres?.toString() ?? '',
  deckingThermalResistancePerMillimetre: response.deckingThermalResistancePerMillimetre?.toString() ?? '',
  deckingThicknessInMillimetres: response.deckingThicknessInMillimetres?.toString() ?? '',
  underlayThermalResistancePerMillimetre: response.underlayThermalResistancePerMillimetre?.toString() ?? '',
  underlayThicknessInMillimetres: response.underlayThicknessInMillimetres?.toString() ?? '',
  overrideTotalHeatLossInWatts: response.userEnteredTotalHeatLossInWatts != null,
  userEnteredTotalHeatLossInWatts: response.userEnteredTotalHeatLossInWatts?.toString() ?? '',
  walls: orderBy(response.walls, wall => wall.displayIndex).map(mapRoomWallHeatLossDetailsResponseToFormModel),
  roofs: orderBy(response.roofs, roof => roof.displayIndex).map(mapRoomRoofHeatLossDetailsResponseToFormModel),
  floors: orderBy(response.floors, floor => floor.displayIndex).map(mapRoomFloorHeatLossDetailsResponseToFormModel),
});
